module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("Faces "), _c('em', [_vm._v("of the")]), _vm._v(" Confederacy")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "car"
    }
  }, [_vm._v("CARTES DE VISITE")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "noindent"
  })]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Capt. Richard Curzon Hoffman, Company E, Thirtieth Battalion Virginia Sharpshooters")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Carte de visite")]), _vm._v(" published by Selby & McCauley of Baltimore, Maryland, from a negative by Stephen Israel (life dates unknown) & Co. of Baltimore, about 1865. Collection of The Museum of the Confederacy, Richmond, Virginia.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d38632","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cartesdevisite.vue
// module id = 84
// module chunks = 0